/* eslint-disable max-lines */
import * as array from '../../../../utils/array';
import {
    contains,
    copy,
    hasProperty,
    prop,
    propDoesNotEqual,
    propEquals,
    propValue,
    setKeyValue
} from '../../../../utils/object';
import ProductClassViewModel from '../../viewmodels/productclassviewmodel';
import TesProductViewModel from './tesproductviewmodel';
import etamessaging from '../../shared/etamessaging';
import ko from 'knockout';
import selectProductFromURLParam from '../../shared/selectproductfromurl';

var DropShipNoCustomizationItems = [
    22811, 26783, 30429, 30575, 30579, 30438, 30582, 30436, 30580, 30427, 30435, 21488, 25587, 21566, 12321, 12334,
    22792, 21481, 21484, 19277, 22966, 24051, 24028, 22375, 30583, 30429, 30575, 30579, 30438, 13345, 30582, 30432,
    30436, 30580, 30427, 30435, 22811, 29502
];

function TesViewModel(data, config) {
    ProductClassViewModel.call(this, data, config);

    var sizingChart, activeAttributes;

    this.products(
        this.products()
            .filter(function (product) {
                return typeof product.price !== 'function' ? product.price : product.price();
            })
            .map(function (product) {
                return new TesProductViewModel(product);
            })
    );

    this.isDropShipRestrictedByState = ko.computed(() => {
        const state = this.userDetectedLocation()?.state;
        if (!state) {
            return false;
        }

        return /Burlingham/gi.test(this.manufacturer()) && /hawaii|alaska/gi.test(state);
    });

    this.hasAutoShipDiscount = this.products().some(prop('hasAutoShipDiscount'));

    this.analysis = data.analysis ? analysis(this.analysis, this.products()) : null;

    activeAttributes = getActiveAttributes(this.products(), this.attributes);

    this.productImages = this.productImages.filter(function (image) {
        var attributes = propValue(image.attributes);
        return !attributes || hasActiveAttributes(attributes, activeAttributes);
    });

    this.attributes = attributes(activeAttributes, Object.keys(this.attributes));
    this.hasAttributes = this.attributes && Object.keys(this.attributes).length > 0;
    this.isGiftCertificate = isGiftCertificate(this.id());
    this.isFlyStopper = isFlyStopper(this.id());

    this.postURL =
        '/addtocart/' +
        this.id() +
        (!this.isGiftCertificate ? (this.isFlyStopper ? '/AddFlyStoppers' : '/AddSupply') : '/AddGiftCertificate');

    sizingChart = array.first(this.images(), propEquals('type', 'sizing-chart'));

    this.sizingChartUrl = sizingChart ? sizingChart.url : '';

    this.imageGroups = groupImagesByAttributes(this.productImages);

    if (config.discipline && config.discipline.toLowerCase() === 'western' && this.imageGroups.length) {
        this.imageGroups[0] = this.imageGroups[0].sort(sortWesternFirst);
    }

    this.hasGroups = this.imageGroups.some(function (group) {
        return group.length > 1;
    });

    this.thumbDisplayCount = this.hasGroups ? 5 : 6;

    this.firstImageFromEachGroup = this.imageGroups.map(function (group) {
        return group[0];
    });

    this.defaultImageGroup = this.imageGroups.filter(function (group) {
        return group.every(function (image) {
            return image.attributes && (Object.keys(image.attributes).length === 0 || 'discipline' in image.attributes);
        });
    });

    this.carouselImages = ko.observableArray(
        this.defaultImageGroup.length > 0 ? this.defaultImageGroup[0] : this.firstImageFromEachGroup
    );

    this.selectedImageGroup = ko.observableArray();
    this.selectedImageGroupSwipeIndex = ko.observable(0);

    this.selectedImage(
        this.imageWithAttributeMatches(this.productImages, {
            discipline: config.discipline
        }).image
    );

    this.colorAttributeImages = this.imageGroups.filter(function (imageGroup) {
        return hasProperty(imageGroup[0], 'attributes.color');
    });

    this.hasLowInventory = this.products().some(function (product) {
        return isLowInventory(product.inventory());
    });

    this.inventory = this.products().reduce(function (sum, product) {
        return sum + product.inventory();
    }, 0);

    this.containsOutOfStockProducts = this.products().some(function (product) {
        return product.inventory() === 0 && product.isBackOrder;
    });

    this.containsDropShipProducts = this.products().some(prop('hasDropShipDelay'));

    this.estimatedArrivalDates = ko.observableArray(
        this.products().filter(qualifiesForPreSku).map(prop('estimatedArrivalDate'))
    );

    this.allEtaAreTheSame = allItemsAreEqual(this.estimatedArrivalDates());
    this.qualifiesForPreSku = this.products().some(qualifiesForPreSku);
    this.estimatedArrivalDateFormatted = ko.computed(
        function () {
            return etamessaging.formatEta(
                this.qualifiesForPreSku ? new Date(this.estimatedArrivalDates().sort()[0]) : new Date()
            );
        }.bind(this)
    );

    this.hasCustomization = this.customization() !== 'none';
    this.customizationIsRequired = this.customization() === 'required';
    this.hasDropShipNoCustomization = DropShipNoCustomizationItems.some(
        function (item) {
            if (item === this.itemNumber()) {
                return true;
            }

            return false;
        }.bind(this)
    );

    if (this.hasCustomization) {
        this.showCustomizationHolidayCutoffMessage = this.products().some(product => product.showCustomizationHolidayCutoffDate());

        this.hasProductExcludedFromCustomization =
            this.hasCustomization && this.products().some(prop('excludeFromCustomization'));
        this.customizationMessage = ko.computed(
            function () {
                var selectedProduct = this.selectedProduct();

                return this.hasProductExcludedFromCustomization
                    ? 'Customization is available for some selections'
                    : !this.hasProductExcludedFromCustomization && this.customizationIsRequired
                        ? 'Customization is required for this item!'
                        : (!selectedProduct &&
                            !this.hasProductExcludedFromCustomization &&
                            !this.customizationIsRequired) ||
                            (selectedProduct && !selectedProduct.excludeFromCustomization())
                            ? 'Customization is available for this item!'
                            : 'Customization is not available for this item';
            }.bind(this)
        );

        this.customizationData = ko.observable();

        this.customizationData.subscribe(
            function (data) {
                if (this.selectedProduct()) {
                    this.updateProductETA(this.id(), this.selectedProductId(), this.selectedProduct(), data);
                }
            }.bind(this)
        );

        this.selectedProduct.subscribe(
            function (product) {
                if (product) {
                    this.updateProductETA(this.id(), product.id(), product, this.customizationData());
                }
            }.bind(this)
        );
    }

    if (this.isFlyStopper) {
        this.isAutoShip = ko.observable(true);
        this.selectedFrequency = ko.observable();
        this.selectedZone = ko.observable();
        this.selectedZoneName = ko.observable();

        this.autoShipAppliedPrice = ko.computed(
            function () {
                var price = this.selectedPrice(),
                    DELIMITER = ' - ',
                    PRICE_RANGE_COUNT = 2,
                    pieces,
                    current,
                    percent;

                if (!price) {
                    return '';
                }

                current = price.current();
                pieces = current.split(DELIMITER);
                percent =
                    price.autoShipDiscount && price.autoShipDiscount.percentOff
                        ? price.autoShipDiscount.percentOff()
                        : 0;

                return pieces.length === PRICE_RANGE_COUNT
                    ? pieces[0] + DELIMITER + formatAutoShipDiscount(pieces[1], percent)
                    : formatAutoShipDiscount(current, percent);
            }.bind(this)
        );

        this.zones = this.zones().map(function (zone) {
            return new FlyZone(zone);
        });

        this.selectedZoneName.subscribe(
            function (val) {
                var zoneObj = '';

                if (val) {
                    this.zones.forEach(function (zone) {
                        if (zone.name === val) {
                            zoneObj = zone;
                        }
                    });
                }

                this.selectedZone(zoneObj);
            }.bind(this)
        );

        this.shipments = ko.computed(
            function () {
                var zone = this.selectedZone(),
                    days = this.selectedFrequency();

                return zone && days ? getShipmentDates(zone.startDate, zone.endDate, +days).map(shipment) : [];
            }.bind(this)
        );

        this.isYearRound = ko.computed(
            function () {
                var zone = this.selectedZone();
                return zone ? this.selectedZone().name === 'Year-round' : '';
            }.bind(this)
        );
    }

    if (this.hasAttributes) {
        this.selectedAttributes.subscribe(
            function (selectedAttributes) {
                var imageWithAttributeMatches = this.imageWithAttributeMatches(this.productImages, selectedAttributes);

                if (this.selectedImage() !== imageWithAttributeMatches.image && imageWithAttributeMatches.matches) {
                    this.carouselImages(this.findImageGroupByImage(imageWithAttributeMatches.image));
                    this.selectedImage(imageWithAttributeMatches.image);
                    this.selectedImageGroupSwipeIndex(0);
                }

                this.selectedProduct(
                    array.first(this.products(), function (product) {
                        return contains(selectedAttributes, ko.toJS(product.attributes));
                    })
                );

                if (this.isGiftCertificate) {
                    this.handleGiftCertificateAttributeChanges(selectedAttributes);
                }
            }.bind(this)
        );

        this.selectedProduct.subscribe(
            function (product) {
                this.selectedProductId(product && product.id());
            }.bind(this)
        );

        if (this.isGiftCertificate || this.isFlyStopper) {
            this.attributes[0].values(this.attributes[0].originalValues);

            setupDependentAttributeSubscribers(this.attributes, this.products(), this.selectedAttributes);

            if (this.isGiftCertificate) {
                this.emailGiftCertificateIsSelected = ko.observable(false);
                this.sponsorGiftCertificateIsSelected = ko.observable(false);
                this.barnGiftCertificateIsSelected = ko.observable(false);
                this.emailGiftCertificateMessage = ko.observable('');

                this.setDefaultGiftCertificateDiscipline = function () {
                    var disciplineAttribute = this.attributes[1];
                    disciplineAttribute.selected(disciplineAttribute.originalValues[0]);
                };

                this.handleGiftCertificateAttributeChanges = function (selectedAttributes) {
                    this.emailGiftCertificateIsSelected(
                        contains(selectedAttributes, {
                            'certificate Option': 'eCertificate delivered via email'
                        })
                    );
                    this.sponsorGiftCertificateIsSelected(
                        contains(selectedAttributes, {
                            'certificate Option': 'Sponsor'
                        })
                    );
                    this.barnGiftCertificateIsSelected(
                        contains(selectedAttributes, {
                            'certificate Option': 'Barn'
                        })
                    );

                    if (
                        this.emailGiftCertificateIsSelected() ||
                        this.sponsorGiftCertificateIsSelected() ||
                        this.barnGiftCertificateIsSelected()
                    ) {
                        this.setDefaultGiftCertificateDiscipline();
                    }
                };

                this.typeId = ko.computed(
                    function () {
                        var EMAIL = 1,
                            PAPER = 2,
                            SPONSOR = 3,
                            BARN = 4;

                        return this.emailGiftCertificateIsSelected()
                            ? EMAIL
                            : this.sponsorGiftCertificateIsSelected()
                                ? SPONSOR
                                : this.barnGiftCertificateIsSelected()
                                    ? BARN
                                    : PAPER;
                    }.bind(this)
                );

                $.get('/api/user/status').done(response => {
                    if (smartPak.HTTP_STATUS_OK === response.status && !response.content.isSpeUser) {
                        removeSponsorOption(this.attributes);
                        removeBarnOption(this.attributes);
                    }
                });
            }
        } else {
            this.vocActiveAttributes = getVOCActiveAttributes(this.products(), data.attributes);

            this.colorSwatches = data.swatches
                ? data.swatches.reduce(function (obj, swatch) {
                    if (!obj[swatch.attributes.color]) {
                        obj[swatch.attributes.color] = swatch;
                    }
                    return obj;
                }, {})
                : [];

            this.attributes = getVOCAttributes(
                this.vocActiveAttributes,
                Object.keys(data.attributes),
                this.colorSwatches
            );

            this.attributeCombinations = this.products().map(function (product) {
                return ko.toJS(product.attributes);
            });

            this.preSelectAttributesWithOnlyOneAvailableOption();
        }
    } else {
        this.selectedProductId.subscribe(
            function (id) {
                this.selectedProduct(
                    array.first(this.products(), function (product) {
                        return +product.id() === +id;
                    })
                );
            }.bind(this)
        );
    }

    this.incrementQuantity = function () {
        this.quantity(+this.quantity() + 1);
    };

    this.decrementQuantity = function () {
        if (this.quantity() > 1) {
            this.quantity(+this.quantity() - 1);
        }
    };

    if (this.products().length === 1) {
        this.selectedProductId(this.products()[0].id());
    }

    this.hasNoAddOnItems =
        this.products().filter(function (item) {
            return item.isAddOnItem() === false;
        }).length === this.products().length;

    this.hasAllAddOnItems =
        this.products().filter(function (item) {
            return item.isAddOnItem() === true;
        }).length === this.products().length;

    if (location.search) {
        selectProductFromURLParam(this);
    }
}

TesViewModel.prototype._findCombinations = function (search) {
    return array.flattenByKeys(
        this.attributeCombinations.filter(function (combo) {
            return contains(combo, search);
        })
    );
};

TesViewModel.prototype._keyValueNotAvailable = function (selectedAttributes, key, value) {
    var combos = this._findCombinations(copyWithoutKey(selectedAttributes, key));
    return !combos[key] || !array.contains(combos[key], value);
};

TesViewModel.prototype.handleAttributeClick = function (attribute) {
    var found = this.attributes.filter(function (attr) {
        return attr.key === attribute.key;
    })[0];

    if (found) {
        found.selected(attribute.value);
    }
    this.onAttributeChange(attribute);
};

TesViewModel.prototype.onAttributeChange = function (attribute) {
    var combo,
        selectedAttributes = setKeyValue(
            copy(ko.utils.unwrapObservable(this.selectedAttributes)),
            attribute.key,
            attribute.value
        ),
        previouslySelectedAttributes = copy(selectedAttributes);

    if (this._keyValueNotAvailable(selectedAttributes, attribute.key, attribute.value)) {
        this.attributes.filter(propDoesNotEqual('key', attribute.key)).forEach(
            function (attr) {
                if (attr.selected() && this._keyValueNotAvailable(selectedAttributes, attr.key, attr.selected())) {
                    delete selectedAttributes[attr.key];
                    attr.selected('');
                }
            }.bind(this)
        );
    }

    this.attributes.forEach(
        function (attr) {
            var activeValues;
            combo = this._findCombinations(copyWithoutKey(selectedAttributes, attr.key));
            attr.values().forEach(function (value) {
                value.disabled(!array.contains(combo[attr.key], value.value));
            });
            activeValues = attr.values().filter(propEquals('disabled', !1)).map(prop('value'));
            if (
                previouslySelectedAttributes[attr.key] &&
                !selectedAttributes[attr.key] &&
                array.contains(activeValues, previouslySelectedAttributes[attr.key])
            ) {
                selectedAttributes[attr.key] = previouslySelectedAttributes[attr.key];
                attr.selected(previouslySelectedAttributes[attr.key]);
            }
        }.bind(this)
    );

    this.selectedAttributes(selectedAttributes);
};

TesViewModel.prototype.preSelectAttributesWithOnlyOneAvailableOption = function () {
    this.attributes
        .filter(function (attr) {
            return attr.values().length === 1;
        })
        .forEach(
            function (attr) {
                var attribute = attr.values()[0];
                attr.selected(attribute.value);
                this.onAttributeChange(attribute);
            }.bind(this)
        );
};

TesViewModel.prototype.findImageGroupByImage = function (image) {
    return this.imageGroups.filter(function (group) {
        return (
            group.filter(function (groupImage) {
                return groupImage === image;
            }).length > 0
        );
    })[0];
};

function analysis(analysis, products) {
    var pakProduct = array.first(products, propEquals('type', 'supplement')),
        maintenanceDose = !pakProduct ? null : array.first(pakProduct.dosingInfo(), propEquals('type', 'maintenance'));

    analysis.maintenanceDoseDescription = maintenanceDose ? maintenanceDose.description() : undefined;

    analysis.hasPerPoundIngredient = !analysis.ingredients().every(propEquals('amountPerPound', ''));

    analysis.ingredients(
        analysis.ingredients().map(function (ingredient) {
            var paranRegex = /\(.*\)/gi,
                match = ingredient.name().match(paranRegex);

            ingredient.paranText = match ? match[0] : '';
            ingredient.name = ingredient.name().replace(paranRegex, '');

            return ingredient;
        })
    );

    return analysis;
}

function sortWesternFirst(a, b) {
    return b.attributes && b.attributes.discipline && b.attributes.discipline().toLowerCase() === 'western' ? 1 : -1;
}

function getActiveAttributes(products, originalAttributes) {
    var active = products.reduce(function (attributes, product) {
        return addUniqueAttributes(product.attributes, attributes);
    }, {});

    Object.keys(active).forEach(function (key) {
        active[key] = originalAttributes[key]().filter(function (val) {
            return active[key].indexOf(val) > -1;
        });
    });

    return active;
}

function addUniqueAttributes(attributes, output) {
    return Object.keys(attributes).reduce(function (output, key) {
        var value = attributes[key]();

        if (!output[key]) {
            output[key] = [];
        }

        if (output[key].indexOf(value) === -1) {
            output[key].push(value);
        }

        return output;
    }, output);
}

function FlyZone(zone) {
    var start = new Date(zone.startDate()),
        end = zone.endDate() ? new Date(zone.endDate()) : new Date(oneYearAfter(new Date(zone.startDate())));

    this.name = zone.name();
    this.startDate = start;
    this.endDate = end;
    this.weekdayMonthDayStartDate = weekdayMonthDay(start);
    this.weekdayMonthDayEndDate = weekdayMonthDay(end);
    this.monthDayYearStartDate = monthDayYear(start);
    this.monthDayYearEndDate = monthDayYear(end);
}

function shipment(date, index) {
    return {
        name: 'Shipment ' + (index + 1),
        date: date
    };
}

function getDateDaysInTheFuture(start, days) {
    return new Date(start.setDate(start.getDate() + days));
}

function getShipmentDates(start, end, intervalInDays) {
    var shipments = [],
        next = new Date(start),
        finalTime = new Date(end).getTime();

    while (next.getTime() < finalTime) {
        shipments.push(weekdayMonthDay(next));
        next = getDateDaysInTheFuture(new Date(next.getTime()), intervalInDays);
    }

    return shipments;
}

function weekdayMonthDay(date) {
    return dayOfTheWeek(date.getUTCDay()) + ' ' + (date.getUTCMonth() + 1) + '/' + date.getUTCDate();
}

function monthDayYear(date) {
    return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
}

function oneYearAfter(date) {
    return date.setFullYear(date.getFullYear() + 1);
}

function dayOfTheWeek(dayIndex) {
    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][dayIndex];
}

function formatAutoShipDiscount(cost, percent) {
    return '$' + applyAutoShipDiscount(currencyToNumber(cost), percent).toFixed(2);
}

function applyAutoShipDiscount(cost, percent) {
    return cost * ((100 - percent) / 100).toFixed(2);
}

function addToGroupKeyValue(group, key, value) {
    if (!group[key]) {
        group[key] = [];
    }

    group[key].push(value);
}

function groupImagesByAttributes(images) {
    var imagesInGroups = imageGroupDictionary(images);

    return Object.keys(imagesInGroups).map(function (key) {
        return imagesInGroups[key];
    });
}

function imageGroupDictionary(images) {
    return images.reduce(function (groups, image) {
        var UNDEF = 'undefined',
            attributes = propValue(image.attributes);

        if (!attributes || !Object.keys(attributes).length || (attributes && attributes.discipline)) {
            addToGroupKeyValue(groups, UNDEF, image);
        } else {
            Object.keys(attributes).reduce(function (groups, key) {
                addToGroupKeyValue(groups, attributes[key](), image);
                return groups;
            }, groups);
        }

        return groups;
    }, {});
}

function removeSponsorOption(attributes) {
    var certOptions = array.first(attributes, propEquals('key', 'certificate Option'));

    if (certOptions) {
        certOptions.originalValues = certOptions.originalValues.filter(function (value) {
            return value !== 'Sponsor';
        });
        certOptions.values(certOptions.originalValues);
    }
}

function removeBarnOption(attributes) {
    var certOptions = array.first(attributes, propEquals('key', 'certificate Option'));

    if (certOptions) {
        certOptions.originalValues = certOptions.originalValues.filter(function (value) {
            return value !== 'Barn';
        });
        certOptions.values(certOptions.originalValues);
    }
}

function setupDependentAttributeSubscribers(attributes, products, selectedAttributes) {
    var attributeCombinations = products.map(function (product) {
        return ko.toJS(product.attributes);
    });

    attributes.forEach(function (attribute, index, attributes) {
        attribute.selected.subscribe(
            handleDependAttributeChanges(attribute, attributes[index + 1], attributeCombinations, selectedAttributes)
        );
    });
}

function handleDependAttributeChanges(attribute, nextAttribute, attributeCombinations, selectedAttributes) {
    return function (value) {
        selectedAttributes(setKeyValue(ko.utils.unwrapObservable(selectedAttributes), attribute.key, value));

        if (nextAttribute) {
            if (value) {
                nextAttribute.values(
                    findNextAttributeValues(
                        attribute.lookupKeys,
                        nextAttribute,
                        selectedAttributes(),
                        attributeCombinations
                    )
                );

                if (nextAttribute.selected() && nextAttribute.values().indexOf(nextAttribute.selected()) > -1) {
                    nextAttribute.selected.valueHasMutated();
                } else {
                    nextAttribute.selected(undefined);
                }
            } else {
                nextAttribute.values([]);
                nextAttribute.selected(undefined);
            }
        }
    };
}

function findNextAttributeValues(lookupKeys, nextAttribute, selectedAttributes, attributeCombinations) {
    var values = attributeCombinations
        .filter(combinationMatch(getSearchCombinations(lookupKeys, selectedAttributes)))
        .map(prop(nextAttribute.key))
        .filter(unique);

    return nextAttribute.originalValues.filter(v => values.includes(v));
}

function combinationMatch(find) {
    return function (attributeCombination) {
        return contains(attributeCombination, find);
    };
}

function getSearchCombinations(lookupKeys, attributes) {
    return Object.keys(attributes)
        .filter(function (key) {
            return lookupKeys.indexOf(key) > -1;
        })
        .reduce(function (obj, key) {
            return setKeyValue(obj, key, attributes[key]);
        }, {});
}

function unique(item, index, array) {
    return item !== array[index - 1];
}

function currencyToNumber(str) {
    return +str.replace(/(^\$|,|\s)/g, '');
}

function attribute(key, index, attributes, attributeOrder) {
    return {
        key: key,
        name: key.substring(0, 1).toUpperCase() + key.substring(1),
        originalValues: attributes[key],
        values: ko.observableArray(),
        selected: ko.observable(),
        lookupKeys: attributeOrder.slice(0, index + 1)
    };
}

function attributes(attributes, attributeOrder) {
    return !attributes
        ? []
        : attributeOrder.map(function (key, index) {
            return attribute(key, index, attributes, attributeOrder);
        });
}

function isGiftCertificate(id) {
    var GIFT_CERT_ID = 2830;
    return id === GIFT_CERT_ID;
}

function isFlyStopper(id) {
    var FLY_STOPPER_ID = 17055;
    return id === FLY_STOPPER_ID;
}

function qualifiesForPreSku(product) {
    return !product.isBackOrder && !product.hasDropShipDelay;
}

function allItemsAreEqual(items) {
    var sortedItems = items.sort();
    return sortedItems[0] === sortedItems[sortedItems.length - 1];
}

function isLowInventory(inventory) {
    var LOWER_INVENTORY_MESSAGE_THRESHOLD = 10;
    return inventory <= LOWER_INVENTORY_MESSAGE_THRESHOLD && inventory > 0;
}

function hasActiveAttributes(attributes, activeAttributes) {
    var keys = Object.keys(attributes).filter(function (key) {
        return key !== 'discipline';
    }),
        matches = keys.filter(function (key) {
            return activeAttributes[key] && activeAttributes[key].indexOf(attributes[key]()) > -1;
        });

    return keys.length === matches.length;
}

function getVOCAttributes(attributes, attributeOrder, colorSwatches) {
    return !attributes
        ? []
        : attributeOrder.map(function (key) {
            return vocAttribute(key, attributes, colorSwatches);
        });
}

function vocAttribute(key, attributes, colorSwatches) {
    var name = key.substring(0, 1).toUpperCase() + key.substring(1),
        blankColorSwatch = {
            url: null,
            hex: null
        },
        values = attributes[key].map(function (val) {
            return Object.assign(
                {
                    key: key,
                    disabled: ko.observable(!1),
                    label: name + ' ' + val,
                    value: val
                },
                colorSwatches[val] ? colorSwatches[val] : blankColorSwatch
            );
        });

    if (key === 'color') {
        values = values.sort(sortSwatchesMissingDataLast);
    }

    return {
        key: key,
        name: name,
        values: ko.observableArray(values),
        selected: ko.observable()
    };
}

function sortSwatchesMissingDataLast(a) {
    return !a.hex && !a.url ? 1 : -1;
}

function getVOCActiveAttributes(products, originalAttributes) {
    var active = products.reduce(function (attributes, product) {
        return (function addUniqueAttributes(attributes, output) {
            return Object.keys(attributes).reduce(function (output, key) {
                var value = attributes[key]();
                if (!output[key]) {
                    output[key] = [];
                }
                if (-1 === output[key].indexOf(value)) {
                    output[key].push(value);
                }
                return output;
            }, output);
        })(product.attributes, attributes);
    }, {});

    Object.keys(active).forEach(function (key) {
        active[key] = (function getValue(obj, key) {
            return 'function' == typeof obj[key] ? obj[key]() : obj[key];
        })(originalAttributes, key).filter(function (val) {
            return -1 < active[key].indexOf(val);
        });
    });

    return active;
}

function copyWithoutKey(obj, key) {
    var result = copy(obj);
    delete result[key];
    return result;
}

export default TesViewModel;
